import BaseService from "./BaseService";
import { QuestionnaireRequest, QuestionnaireResponse, QuestionnairesResponse } from "./mappers/QuestionnaireMapper";

class QuestionnaireService extends BaseService {
  constructor() {
    super();
  }

  createQuestionnaire(data) {
    return this.post(`questionnaires/`, QuestionnaireRequest(data))
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  createCompanyQuestionnaire(id, data) {
    return this.post(`companies/${id}/questionnaires/`, QuestionnaireRequest(data))
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  copyQuestionnaire(id) {
    return this.post(`/questionnaires/${id}/copy/`, {})
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  getQuestionnaire(id) {
    return this.get(`questionnaires/${id}/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  getOnboardingQuestionnaire() {
    return this.get(`system/onboarding-questionnaire/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  getQuestionnaires() {
    return this.get(`questionnaires/`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesByType(type) {
    return this.get(`questionnaires/?questionnaire_type=${type}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesByPartnerAndType(type) {
    return this.get(`partner/questionnaires/?questionnaire_type=${type}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesBySystemAndType(type) {
    return this.get(`system/questionnaires/?questionnaire_type=${type}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesBySystem() {
    return this.get(`system/questionnaires/`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesBySystemAndActivateByDefault(activateByDefault) {
    return this.get(`system/questionnaires/?activate_by_default=${activateByDefault}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesByCompanyAndType(companyId, type) {
    return this.get(`companies/${companyId}/questionnaires/?questionnaire_type=${type}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getQuestionnairesByCompany(companyId, search = "", ids = "") {
    return this.get(`companies/${companyId}/questionnaires/?ids=${ids}&search=${search}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  getMyQuestionnairesByType(type, search = "", ids = "") {
    return this.get(`my/questionnaires/?id=${ids}&questionnaire_type=${type}&search=${search}`)
      .then((response) => response.data)
      .then((data) => QuestionnairesResponse(data));
  }

  updateQuestionnaire(id, data) {
    return this.patch(`questionnaires/${id}/`, QuestionnaireRequest(data))
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  deleteQuestionnaire(id) {
    return this.delete(`questionnaires/${id}/`);
  }

  translateQuestionnaireToEnglish(id) {
    return this.put(`questionnaires/${id}/translatetoenglish/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  translateQuestionnaireToNorwegian(id) {
    return this.put(`questionnaires/${id}/translatetonorwegian/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  translateQuestionnaireToDanish(id) {
    return this.put(`questionnaires/${id}/translatetodanish/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  clearTranslation(id) {
    return this.put(`questionnaires/${id}/cleartranslation/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  generateExternalUrl(id) {
    return this.post(`/questionnaires/${id}/generateexternalurl/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  clearExternalUrl(id) {
    return this.post(`/questionnaires/${id}/clearexternalurl/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }

  getExternalQuestionnaire(v, token, id) {
    return this.get(`external/questionnaire/${v}/${token}/${id}/`)
      .then((response) => response.data)
      .then((data) => QuestionnaireResponse(data));
  }
}

export default new QuestionnaireService();
